import { render } from "./VignettePrices.vue?vue&type=template&id=7e7a9962"
import script from "./VignettePrices.vue?vue&type=script&setup=true&lang=js"
export * from "./VignettePrices.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/VignettePrices.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e7a9962"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e7a9962', __exports__)) {
    api.reload('7e7a9962', __exports__)
  }
  
  module.hot.accept("./VignettePrices.vue?vue&type=template&id=7e7a9962", () => {
    api.rerender('7e7a9962', render)
  })

}


export default __exports__